import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchReferralGetListing,
  type TReferralGetListingResponse,
} from '../../../repositories/cpd/v1/referral/get-listing';
import { HttpBadStatusCodeError } from '@cian/peperrors';
import type { IReferralItem } from '../../../repositories/cpd/entities/v1_get_referrals_listing/ReferralItem';
import { IThunkApi } from '../../../types/referrer/store';

export const getReferralListing = createAsyncThunk<IReferralItem[], undefined, IThunkApi>(
  'cpd/getReferralListing',
  async (_, _thunkApi) => {
    const {
      extra: { httpApi, logger },
    } = _thunkApi;

    try {
      const res = (await fetchReferralGetListing({
        httpApi,
      })) as TReferralGetListingResponse;

      if (res.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: res.statusCode,
          domain: 'getReferralListing.ts',
          message: res.response.message,
        });
      }

      return res.response.referrals;
    } catch (e) {
      logger.debug('Ошибка загрузки листинга рефералов', {
        message: e.message,
        domain: e.domain,
      });

      throw e;
    }
  },
);
